import Vue from "vue";
import VueMq from "vue-mq";
import "material-design-icons-iconfont/dist/material-design-icons.css";

import NsProductMixin from "./mixins/NsProductMixin.js";

import NsProductCardBase from "./components/NsProductCardBase.vue";
import NsProductCard from "./components/NsProductCard.vue";
import NsProductDetailBase from "./components/NsProductDetailBase.vue";
import NsProductDetail from "./components/NsProductDetail.vue";
import NsProductCarousel from "./components/NsProductCarousel.vue";
import NsProductList from "./components/NsProductList.vue";
import NsProductListSortable from "./components/NsProductListSortable.vue";
import NsProductLine from "./components/NsProductLine.vue";

window.Vue = Vue;
Vue.config.silent = true;

Vue.use(VueMq, {
  breakpoints: {
    mobile: 375,
    phablet: 768,
    tablet: 1024,
    desktop: 1440,
    desktopHD: Infinity
  }
});

export {
  NsProductMixin,
  NsProductCardBase,
  NsProductCard,
  NsProductDetailBase,
  NsProductDetail,
  NsProductCarousel,
  NsProductList,
  NsProductListSortable,
  NsProductLine
};
